import {
  occurrenceListSchema,
  type ListOccurrencesQuery,
  type OccurrenceList,
} from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const searchOf = (query: ListOccurrencesQuery): string => {
  const params = new URLSearchParams();

  if (query.status !== undefined) {
    params.set('status', query.status);
  }
  if (query.paymentId !== undefined) {
    params.set('paymentId', query.paymentId);
  }
  if (query.from !== undefined) {
    params.set('from', query.from);
  }
  if (query.to !== undefined) {
    params.set('to', query.to);
  }

  const search = params.toString();

  if (search === '') {
    return '';
  }

  return `?${search}`;
};

const fetchOccurrences = (query: ListOccurrencesQuery, signal: AbortSignal): Promise<unknown> =>
  apiRequest<unknown>(`/occurrences${searchOf(query)}`, { signal });

export const getOccurrences = async (
  query: ListOccurrencesQuery,
  signal: AbortSignal,
): Promise<OccurrenceList> => occurrenceListSchema.parse(await fetchOccurrences(query, signal));
